import getConfig from "next/config"
import React from "react"

import { FreeNotice } from "~/app/Free/Page/FreeNotice"
import { distribution } from "~/config"
import { Fetcher } from "~/external/Fetcher"
import { NoticeCatalogsPresenter } from "~/presenter/NoticeCatalogsPresenter"
import { NoticeCatalogsTopPresenter } from "~/presenter/NoticeCatalogsTopPresenter"
import { Notice, NoticeCatalogsRepository } from "~/repository/NoticeCatalogsRepository"
import { NoticeCatalogsTopRepository } from "~/repository/NoticeCatalogsTopRepository"

import { NoticeCatalogsPresenter as PaidNoticeCatalogsPresenter } from "../../app/Paid/model/presenter/NoticeCatalogsPresenter"
import { NoticeCatalogsRepository as PaidNoticeCatalogsRepository } from "../../app/Paid/model/repository/NoticeCatalogsRepository"
import { PaidNotice } from "../../app/Paid/Page/PaidNotice"
// import { PortalNotice } from "../../app/Portal/Page/PortalNotice"
import { TopNotice } from "../../app/Top/Page/TopNotice"
type NoticeProps = {
  notice: Notice
  distribution: string
  configDomain: {
    paid: string
    top: string
    free: string
  }
}

const NoticePage: React.FC<NoticeProps> = (props) => {
  const { distribution } = props
  return (
    <>
      {(() => {
        switch (distribution) {
          case "free":
            return <FreeNotice {...props} />
          /*case "portal":
            return <PortalNotice {...props} />*/
          case "paid":
            return <PaidNotice {...props} />
          case "top":
            return <TopNotice {...props} />
          default:
            return <TopNotice {...props} />
        }
      })()}
    </>
  )
}

export default NoticePage

export const getStaticPaths = async () => {
  const {
    serverRuntimeConfig: { cmsEndpointPaid, cmsApiKeyPaid, cmsEndpoint, cmsApiKey }
  } = await import("../../../next.config")

  /**
   * notice for paid
   */
  if (distribution === "paid") {
    const fetcher = new Fetcher({ cmsEndpoint: cmsEndpointPaid, cmsApiKey: cmsApiKeyPaid })
    const noticeCatalogsRepo = new PaidNoticeCatalogsRepository(fetcher)
    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const paths = PaidNoticeCatalogsPresenter.transform(noticeCatalogs).map((content) => `/notices/${content.id}`)
    return { paths, fallback: false }
  }

  if (distribution === "portal") {
    const fetcher = new Fetcher({ cmsEndpoint, cmsApiKey })
    const noticeCatalogsRepo = new NoticeCatalogsRepository(fetcher)
    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const paths = NoticeCatalogsPresenter.transform(noticeCatalogs).map((content) => `/notices/${content.id}`)

    return { paths, fallback: false }
  }

  if (distribution === "top") {
    const fetcher = new Fetcher({ cmsEndpoint: cmsEndpointPaid, cmsApiKey: cmsApiKeyPaid })
    const noticeCatalogsRepo = new NoticeCatalogsTopRepository(fetcher)
    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const paths = NoticeCatalogsTopPresenter.transform(noticeCatalogs).map((content) => `/notices/${content.id}`)

    return { paths, fallback: false }
  }

  if (distribution === "free") {
    const fetcher = new Fetcher({ cmsEndpoint, cmsApiKey })
    const noticeCatalogsRepo = new NoticeCatalogsRepository(fetcher)
    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const paths = NoticeCatalogsPresenter.transform(noticeCatalogs).map((content) => `/notices/${content.id}`)

    return { paths, fallback: false }
  }
}

export const getStaticProps = async ({ params }: { params: { id: string } }) => {
  const {
    serverRuntimeConfig: { cmsEndpointPaid, cmsApiKeyPaid, cmsEndpoint, cmsApiKey, configDomain }
  } = getConfig()
  /**
   * notice for paid
   */
  if (distribution === "paid") {
    const fetcher = new Fetcher({ cmsEndpoint: cmsEndpointPaid, cmsApiKey: cmsApiKeyPaid })
    const noticeCatalogsRepo = new PaidNoticeCatalogsRepository(fetcher)
    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const noticeCatalog = noticeCatalogs.find((content) => content.notice.id === params.id)
    return {
      props: {
        notice: noticeCatalog?.notice,
        distribution,
        configDomain
      }
    }
  }

  if (distribution === "portal") {
    const fetcher = new Fetcher({ cmsEndpoint, cmsApiKey })
    const noticeCatalogsRepo = new NoticeCatalogsRepository(fetcher)

    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const noticeCatalog = noticeCatalogs.find((content) => content.notice.id === params.id)
    return {
      props: {
        notice: noticeCatalog?.notice,
        distribution,
        configDomain
      }
    }
  }

  if (distribution === "top") {
    const fetcher = new Fetcher({ cmsEndpoint: cmsEndpointPaid, cmsApiKey: cmsApiKeyPaid })
    const noticeCatalogsRepo = new NoticeCatalogsTopRepository(fetcher)
    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const noticeCatalog = noticeCatalogs.find((content) => content.notice.id === params.id)
    return {
      props: {
        notice: noticeCatalog?.notice,
        distribution,
        configDomain
      }
    }
  }

  if (distribution === "free") {
    const fetcher = new Fetcher({ cmsEndpoint, cmsApiKey })
    const noticeCatalogsRepo = new NoticeCatalogsRepository(fetcher)

    const noticeCatalogs = await noticeCatalogsRepo.findAll()
    const noticeCatalog = noticeCatalogs.find((content) => content.notice.id === params.id)
    return {
      props: {
        notice: noticeCatalog?.notice,
        distribution,
        configDomain
      }
    }
  }
}
